import React from 'react';
import styles from './Homepage.module.scss';
import LandingImg from '../../images/landing.jpg'
import LandingPage from './LandingPage/LandingPage';

const Homepage = () => {
  return (
    <div className={styles.homepage}>
      <div className={styles.left}>
        <LandingPage />
      </div>
      <div className={styles.right}>
        <img src={LandingImg} alt="" />
      </div>
    </div>
  );
};

export default Homepage;
